import axiosInstance from './axiosInstance';

const createSubscriptionLink = async ({subscriptionType, token}) => {
  try {
    const response = await axiosInstance.post(
      '/stripe/link',
      {
        subscription_type: subscriptionType
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {createSubscriptionLink};